// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AnonymousAgentInfo = require("../../common/Agent/AnonymousAgentInfo.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql = require("../../../__generated__/AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.bs.js");

let convertFragment = AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

let Fragment_membershipStatusV5_decode = AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_decode;

let Fragment_membershipStatusV5_fromString = AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_fromString;

let Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AnonymousForSalePropertyAgentInfo(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let match = RescriptRelay_Fragment.useFragment(AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent_graphql.node, convertFragment, props.agent);
  return JsxRuntime.jsx(AnonymousAgentInfo.make, {
    size: size,
    isTerminated: match.membershipStatus === "TERMINATED"
  });
}

let make = AnonymousForSalePropertyAgentInfo;

exports.Fragment = Fragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
